import {DEVICE_TYPES} from '@/consts/device/deviceTypes';

const REMAINING_STICKS_VALUES = {
    [DEVICE_TYPES.DEV_TYPE_P1V40C_CHARGER]: {
        capacityConstant: 938,
        voltageThreshold: 106,
        voltageCoefficient: 204,
        levelThreshold: 8,
        levelCoefficient: 166,
        correctionCoefficient: -10,
        energyConstant: 852,
        maxRemainingSticks: 20,
    },
    [DEVICE_TYPES.DEV_TYPE_P1V40V_CHARGER]: {
        capacityConstant: 938,
        voltageThreshold: 106,
        voltageCoefficient: 204,
        levelThreshold: 8,
        levelCoefficient: 166,
        correctionCoefficient: -10,
        energyConstant: 852,
        maxRemainingSticks: 20,
    },
    [DEVICE_TYPES.DEV_TYPE_P1V40D_CONTROL]: {
        capacityConstant: 2123,
        voltageThreshold: 107,
        voltageCoefficient: 88,
        levelThreshold: 20,
        levelCoefficient: 203,
        correctionCoefficient: -25,
        energyConstant: 867,
        maxRemainingSticks: 20,
    },
    [DEVICE_TYPES.DEV_TYPE_P1V41P_CHARGER]: {
        capacityConstant: 938,
        voltageThreshold: 106,
        voltageCoefficient: 204,
        levelThreshold: 8,
        levelCoefficient: 166,
        correctionCoefficient: -10,
        energyConstant: 852,
        maxRemainingSticks: 20,
    },
    [DEVICE_TYPES.DEV_TYPE_P1V41M_CHARGER]: {
        capacityConstant: 938,
        voltageThreshold: 106,
        voltageCoefficient: 204,
        levelThreshold: 8,
        levelCoefficient: 166,
        correctionCoefficient: -10,
        energyConstant: 852,
        maxRemainingSticks: 20,
    },
    [DEVICE_TYPES.DEV_TYPE_P1V41J_CONTROL]: {
        capacityConstant: -62832,
        voltageCoefficient: 17983,
        levelCoefficient: 93.3,
        energyConstant: 890,
        maxRemainingSticks: 20,
    },
    [DEVICE_TYPES.DEV_TYPE_P1V41A_CONTROL]: {
        capacityConstant: -62832,
        voltageCoefficient: 17983,
        levelCoefficient: 93.3,
        energyConstant: 890,
        maxRemainingSticks: 20,
    },
};

export default REMAINING_STICKS_VALUES;
